"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Sidebar/List/Patients/Item.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _peers = require('shared/selectors/peers');
var _org = require('shared/selectors/org');



var _entities = require('shared/transforms/entities');
var _hooks = require('web/services/hooks');

var _GenericItem = require('web/screens/Directory/Sidebar/List/GenericItem'); var _GenericItem2 = _interopRequireDefault(_GenericItem);







const PatientItem = ({ patientKey, orgKey, isViewed }) => {
  const org = _hooks.useAppSelector.call(void 0, state => _org.selectOrgByKey.call(void 0, orgKey, state))
  const patient = _hooks.useAppSelector.call(void 0, state => _peers.selectPatientByKey.call(void 0, state, patientKey))
  const patientEntity = _react.useMemo.call(void 0, 
    () => {
      // SAFETY: the one key is orgKey, and its value is the org stored under it.
      const orgsMap = (org ? { [orgKey]: org } : {}) 
      return patient
        ? _entities.mapPatientToEntity.call(void 0, orgsMap, (0, _entities.makeContactPatientDescription))(patient)
        : null
    },
    [org, orgKey, patient],
  )

  return (
    _react2.default.createElement(_GenericItem2.default, {
      entity: patientEntity,
      orgKey: orgKey,
      isViewed: isViewed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
    )
  )
}

exports. default = _react.memo.call(void 0, PatientItem)
